import { lazyWithPreload } from 'react-lazy-with-preload';

const DocumentListPage = lazyWithPreload(() => import('./pages/document-list/Page'));
const DocumentDetailPage = lazyWithPreload(() => import('./pages/document-detail/Page'));

const Routes = [
    {
        path: 'documents',
        element: <DocumentListPage />,
    },
    {
        path: 'documents/:fileId',
        element: <DocumentDetailPage />,
    },
];

export default Routes;
